import { HARDSHIP_NONE } from '../../components/flows/patientAssistance/PapScoring';
import { PapScreenName, ScreenConfig, ScreenType, SharedScreenName } from '../FlowTypes';

/** Patient Assistance Program (PAP) flow screens — shared across referred Nerva flow configs. */
export const PATIENT_ASSISTANCE_SCREENS: Array<
  ScreenConfig<PapScreenName | SharedScreenName.Payment>
> = [
  {
    screenName: PapScreenName.PapPublicAssistance,
    type: ScreenType.PapPublicAssistance,
    layout: {},
    nextScreen: PapScreenName.PapHouseholdIncome,
  },
  {
    screenName: PapScreenName.PapHouseholdIncome,
    type: ScreenType.PapHouseholdIncome,
    layout: {},
    nextScreen: PapScreenName.PapHardshipFactors,
  },
  {
    screenName: PapScreenName.PapHardshipFactors,
    type: ScreenType.MultiSelect,
    layout: {
      body: ['Have you experienced any of the following in the past 6 months?'],
      choices: [
        'Job loss or significant reduction in hours/income',
        'Major out-of-pocket medical expenses',
        'Caregiving responsibilities affecting ability to work',
        'Housing instability (e.g., eviction risk, homelessness)',
        HARDSHIP_NONE,
      ],
      primaryButtonTitle: 'Continue',
    },
    nextScreen: PapScreenName.PapAffordability,
  },
  {
    screenName: PapScreenName.PapAffordability,
    type: ScreenType.SingleSelect,
    layout: {
      body: ['Without a discount, would you be able to pay for Nerva?'],
      choices: [
        { label: 'Yes', value: 'yes' },
        { label: 'Maybe / Only with difficulty', value: 'maybe' },
        { label: "No, I can't afford any payment this time", value: 'no' },
      ],
    },
    nextScreen: PapScreenName.PapAttestation,
  },
  {
    screenName: PapScreenName.PapAttestation,
    type: ScreenType.MultiSelect,
    layout: {
      body: [
        'I certify the information provided is accurate to the best of my knowledge. I understand assistance is limited and may be reviewed to ensure fairness.',
      ],
      choices: ['I confirm'],
      primaryButtonTitle: 'Submit',
    },
    nextScreen: PapScreenName.PapDiscountResult,
  },
  {
    screenName: PapScreenName.PapDiscountResult,
    type: ScreenType.PapDiscountResult,
    layout: {},
    nextScreen: SharedScreenName.Payment,
  },
];
